











import { Component, Vue } from 'vue-property-decorator';
// import { MERCHANT_CODE } from '@/utils/constant';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'LogoUnion'
})
export default class LogoUnion extends Vue {
  logoUnionImg = '';

  created() {
    this.showLogoUnion();
  }

  showLogoUnion() {
    const invitationCode = getUrlParam('invitationCode');
    let requirePic = '';

    try {
      requirePic = require(`../../assets/images/merchant/logo_union_${ invitationCode }.png`);
    } catch (error) {
      requirePic = require(`../../assets/images/merchant/logo_union_default.png`);
    }

    // 注意：新增logo后要重新打包才生效，且需要将图片放到cdn上
    if (invitationCode) {
      this.logoUnionImg = requirePic;
    }

    /*switch (invitationCode) {
      case MERCHANT_CODE.zxkj:
        this.logoUnionImg = require('../../assets/images/merchant/logo_union_zxkj.png');
        break;
      case MERCHANT_CODE.jrrl:
        this.logoUnionImg = require('../../assets/images/merchant/logo_union_jrrl.png');
        break;
      case MERCHANT_CODE.yr:
        this.logoUnionImg = require('../../assets/images/merchant/logo_union_yr.png');
        break;
      default:
        break;
    }*/
  }
}
